const TimeReporting = {
  TimeReporting: "TimeReporting.TimeReporting",
  TimeReportingInterval_0: "TimeReporting.TimeReportingInterval_0",
  TimeReportingInterval_1: "TimeReporting.TimeReportingInterval_1",
  Projects: "TimeReporting.Projects",
  CreateProject: "TimeReporting.CreateProject",
  EditProject: "TimeReporting.EditProject",
  ReportTime: "TimeReporting.ReportTime",
  FillHours: "TimeReporting.FillHours",
  CreatedTimeReport: "TimeReporting.CreatedTimeReport",
  Compensation: "TimeReporting.Compensation",
  Abscence: "TimeReporting.Abscence",
  DeviatingTime: "TimeReporting.DeviatingTime",
  InternalTime: "TimeReporting.InternalTime",
  ProjectTime: "TimeReporting.ProjectTime",
  Allowance: "TimeReporting.Allowance",
  ToInvoice: "TimeReporting.ToInvoice",
  CalculatedAmount: "TimeReporting.CalculatedAmount",
  Invoiced: "TimeReporting.Invoiced",
  OccupancyRate: "TimeReporting.OccupancyRate",
  ExcludeInvoiced: "TimeReporting.ExcludeInvoiced",
  HoursToInvoice: "TimeReporting.HoursToInvoice",
  DuplicateOfDay: "TimeReporting.DuplicateOfDay",
  InvoiceStatus_0: "TimeReporting.InvoiceStatus_0",
  InvoiceStatus_1: "TimeReporting.InvoiceStatus_1",
  InvoiceStatus_2: "TimeReporting.InvoiceStatus_2",
  InvoiceStatus_3: "TimeReporting.InvoiceStatus_3",
  InvoiceStatus_4: "TimeReporting.InvoiceStatus_4",
  InvoiceStatus_5: "TimeReporting.InvoiceStatus_5",
  InvoiceStatus_6: "TimeReporting.InvoiceStatus_6",
  TotalHours: "TimeReporting.TotalHours",
  WeeklyTimeReport: "TimeReporting.WeeklyTimeReport",
  ThisWeek: "TimeReporting.ThisWeek",
  PreviousWeek: "TimeReporting.PreviousWeek",
  NextWeek: "TimeReporting.NextWeek",
  WeekDayShortFromMonday_0: "TimeReporting.WeekDayShortFromMonday_0",
  WeekDayShortFromMonday_1: "TimeReporting.WeekDayShortFromMonday_1",
  WeekDayShortFromMonday_2: "TimeReporting.WeekDayShortFromMonday_2",
  WeekDayShortFromMonday_3: "TimeReporting.WeekDayShortFromMonday_3",
  WeekDayShortFromMonday_4: "TimeReporting.WeekDayShortFromMonday_4",
  WeekDayShortFromMonday_5: "TimeReporting.WeekDayShortFromMonday_5",
  WeekDayShortFromMonday_6: "TimeReporting.WeekDayShortFromMonday_6",
  TimeWeek: "TimeReporting.TimeWeek",
  WorkedHours: "TimeReporting.WorkedHours",
  ExpectedComp: "TimeReporting.ExpectedComp",
  Absence: "TimeReporting.Absence",
  BillableTime: "TimeReporting.BillableTime",
  TimeReport: "TimeReporting.TimeReport",
  CreateNewProject: "TimeReporting.CreateNewProject",
  TimeReportedSuccess: "TimeReporting.TimeReportedSuccess",
  LockWeek: "TimeReporting.LockWeek",
  UnLockWeek: "TimeReporting.UnLockWeek",
  LockWeekSuccess: "TimeReporting.LockWeekSuccess",
  UnLockWeekSuccess: "TimeReporting.UnLockWeekSuccess",
  LockMonth: "TimeReporting.LockMonth",
  UnLockMonth: "TimeReporting.UnLockMonth",
  LockMonthSuccess: "TimeReporting.LockMonthSuccess",
  UnLockMonthSuccess: "TimeReporting.UnLockMonthSuccess",
  UnLockPreviousWeek: "TimeReporting.UnLockPreviousWeek",
  UnLockPreviousWeekSuccess: "TimeReporting.UnLockPreviousWeekSuccess",
  UnSavedChanges: "TimeReporting.UnSavedChanges",
  SaveChangesBeforeSubmit: "TimeReporting.SaveChangesBeforeSubmit",
  ProjectTimeAlreadyAddedToInvoice: "TimeReporting.ProjectTimeAlreadyAddedToInvoice",
  MemberMustBeActive: "TimeReporting.MemberMustBeActive",
  ProjectMustBeActive: "TimeReporting.ProjectMustBeActive",
  CompTime: "TimeReporting.CompTime",
  CompTimeSubTitle: "TimeReporting.CompTimeSubTitle",
  CompWorkedHours: "TimeReporting.CompWorkedHours",
  PreviousCompHours: "TimeReporting.PreviousCompHours",
  AddOrRemoveCompTime: "TimeReporting.AddOrRemoveCompTime",
  TotalCompTime: "TimeReporting.TotalCompTime",
  DateMustBeEqualOrLaterThanFromDate: "TimeReporting.DateMustBeEqualOrLaterThanFromDate",
  UnLock: "TimeReporting.UnLock",
  Comp: "TimeReporting.Comp",
  Holiday: "TimeReporting.Holiday",
  Child: "TimeReporting.Child",
  TimeLogsTodoTitle: "TimeReporting.TimeLogsTodoTitle",
  SelectionPanelHeader: "TimeReporting.SelectionPanelHeader",
  SelectionPanelSubHeader: "TimeReporting.SelectionPanelSubHeader",
  TimeDeviations: "TimeReporting.TimeDeviations",
  GoToGroupReport: "TimeReporting.GoToGroupReport",
  ReportedTime: "TimeReporting.ReportedTime",
  TimeReportStatus_0: "TimeReporting.TimeReportStatus_0",
  TimeReportStatus_1: "TimeReporting.TimeReportStatus_1",
  TimeReportStatus_2: "TimeReporting.TimeReportStatus_2",
  TimeReportStatus_3: "TimeReporting.TimeReportStatus_3",
  Utilization: "TimeReporting.Utilization",
  Internal: "TimeReporting.Internal",
  AbsenceDeviations: "TimeReporting.AbsenceDeviations",
  SubmitTodoSuccessMessage: "TimeReporting.SubmitTodoSuccessMessage",
  HourlyRate: "TimeReporting.HourlyRate",
  ShowAll: "TimeReporting.ShowAll",
  ThisMonth: "TimeReporting.ThisMonth",
  NextMonth: "TimeReporting.NextMonth",
  PreviousMonth: "TimeReporting.PreviousMonth",
  TimeMonth: "TimeReporting.TimeMonth",
  MonthlyTimeReport: "TimeReporting.MonthlyTimeReport",
  InvoiceDocumentationNotAttestedHeader: "TimeReporting.InvoiceDocumentationNotAttestedHeader",
  InvoiceDocumentationNotAttestedQuery: "TimeReporting.InvoiceDocumentationNotAttestedQuery",
  ProjectPlaceholder: "TimeReporting.ProjectPlaceholder",
  DeviationsPlaceholder: "TimeReporting.DeviationsPlaceholder",
  CompHoursComparedToFullTime: "TimeReporting.CompHoursComparedToFullTime",
  SubmitAllowancesForMonth: "TimeReporting.SubmitAllowancesForMonth",
  SubmitAllowancesDescription: "TimeReporting.SubmitAllowancesDescription",
  AllowancesPlaceholder: "TimeReporting.AllowancesPlaceholder",
  CompTimeMatchesFullTime: "TimeReporting.CompTimeMatchesFullTime",
  Comments: "TimeReporting.Comments",
  External: "TimeReporting.External",
  WeekDayLongFromMonday_0: "TimeReporting.WeekDayLongFromMonday_0",
  WeekDayLongFromMonday_1: "TimeReporting.WeekDayLongFromMonday_1",
  WeekDayLongFromMonday_2: "TimeReporting.WeekDayLongFromMonday_2",
  WeekDayLongFromMonday_3: "TimeReporting.WeekDayLongFromMonday_3",
  WeekDayLongFromMonday_4: "TimeReporting.WeekDayLongFromMonday_4",
  WeekDayLongFromMonday_5: "TimeReporting.WeekDayLongFromMonday_5",
  WeekDayLongFromMonday_6: "TimeReporting.WeekDayLongFromMonday_6",
  ExternalComment: "TimeReporting.ExternalComment",
  InternalComment: "TimeReporting.InternalComment",
  ExportPersons: "TimeReporting.ExportPersons",
  ExportDate: "TimeReporting.ExportDate",
  ExportProject: "TimeReporting.ExportProject",
  ExportCategory: "TimeReporting.ExportCategory",
  ExportHours: "TimeReporting.ExportHours",
  ExportRate: "TimeReporting.ExportRate",
  ExportExternalComment: "TimeReporting.ExportExternalComment",
  ExportInternalComment: "TimeReporting.ExportInternalComment",
  Comment: "TimeReporting.Comment",
  CommentType_0: "TimeReporting.CommentType_0",
  CommentType_1: "TimeReporting.CommentType_1",
  OnlyIncludeHourlyIndividualBillingModel: "TimeReporting.OnlyIncludeHourlyIndividualBillingModel",
  DateInterval: "TimeReporting.DateInterval",
  DateIntervalDescription: "TimeReporting.DateIntervalDescription",
  Month: "TimeReporting.Month",
  InvoiceWithSerialNumber: "TimeReporting.InvoiceWithSerialNumber",
  InvoicePickerDialogTitle: "TimeReporting.InvoicePickerDialogTitle",
  InvoicePickerDialogSubtitle: "TimeReporting.InvoicePickerDialogSubtitle",
  ConnectedInvoices: "TimeReporting.ConnectedInvoices",
  SearchForInvoiceNumber: "TimeReporting.SearchForInvoiceNumber",
  CopyPreviousWeek: "TimeReporting.CopyPreviousWeek",
  CopyPreviousWeekWithoutHours: "TimeReporting.CopyPreviousWeekWithoutHours",
  CopyPreviousWeekNoProjectsMessage: "TimeReporting.CopyPreviousWeekNoProjectsMessage",
  CopyPreviousWeekFailedMessage: "TimeReporting.CopyPreviousWeekFailedMessage",
  PreviousWeekEmptyMessage: "TimeReporting.PreviousWeekEmptyMessage",
  ConfirmReports: "TimeReporting.ConfirmReports",
  ConfirmReportsDescription: "TimeReporting.ConfirmReportsDescription",
  ClickToChange: "TimeReporting.ClickToChange",
  ConfirmTimeReports: "TimeReporting.ConfirmTimeReports",
  ConfirmTimeReportsDescription: "TimeReporting.ConfirmTimeReportsDescription",
  }
export default TimeReporting;